import { graphql, useStaticQuery } from 'gatsby';

export default function FinanceMenuLinks() {
  const FinanceMenu = useStaticQuery(graphql`
    query MyFinanceQuery {
      allMenuLinkContentFinance {
        nodes {
          id: drupal_id
          langcode
          parent: drupal_parent_menu_item
          link {
            uri
          }
          title
          weight
        }
      }
      allPathAliasPathAlias {
        nodes {
          alias
          langcode
          path
        }
      }
    }
  `);

  return FinanceMenu;
}
